module.exports = __webpack_public_path__ + "static/media/dans1Grey.50007a03.png";